import { createContext, useContext, useState, useEffect, ReactNode } from 'react';
import { useLocation } from 'react-router-dom';

interface LeadContextType {
  collegeName: string;
  collegeCode: string;
  setLeadContext: (name: string, code: string) => void;
}

const LeadContext = createContext<LeadContextType>({
  collegeName: '',
  collegeCode: '',
  setLeadContext: () => {},
});

export const LeadProvider = ({ children }: { children: ReactNode }) => {
  const [collegeName, setCollegeName] = useState('');
  const [collegeCode, setCollegeCode] = useState('');
  const location = useLocation();

  // Clear college context when navigating away from college detail pages
  useEffect(() => {
    if (!location.pathname.startsWith('/colleges/')) {
      setCollegeName('');
      setCollegeCode('');
    }
  }, [location.pathname]);

  const setLeadContext = (name: string, code: string) => {
    setCollegeName(name);
    setCollegeCode(code);
  };

  return (
    <LeadContext.Provider value={{ collegeName, collegeCode, setLeadContext }}>
      {children}
    </LeadContext.Provider>
  );
};

export const useLeadContext = () => useContext(LeadContext);
